/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 *
 */

const pageContext = $('meta[name=context-path]').attr('content');
const CSRF = $("meta[name='csrf-token']").attr('content');

$('.notification-wrapper').click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $('.notify-dropdown').toggle();
});

$('.notify-dropdown').click((e) => {   
    e.stopPropagation();
});

$('body').click(() => {   
    $('.notify-dropdown').hide();
});


$('#unread-notification').click(() => {
    const seenTrueu = pageContext + "/notification/seen-true";
    const param = "_tk=" + CSRF;
    $.ajax({
        type: "POST",
        url: seenTrueu,
        data: param,
        success: function (response) {},
        error: function(error){},
        complete: function(){}
    });
});